import { Typography, useMediaQuery, Box, useTheme, CircularProgress } from '@mui/material';
import React, { useEffect, useRef } from 'react';

import ChatBanner from '../../../shared/chatBanner/ChatBanner';
import MarkdownRenderer from '../../../shared/markdownRenderer/MarkdownRenderer';
import { useDownloadAgentMdQuery } from '../../../data/api/endPointsSlice';
import { ApiError, showSnackbarErrorMessage } from '../../../shared/utiles/Utiles';
import { AgentMarketPlaceItemWithFilter } from '../agentMarketPlace/AgentMarketPlace';

interface commingSoonChatProps {
  setShowCommingSoonChat: React.Dispatch<React.SetStateAction<boolean>>;
  setShowChat: React.Dispatch<React.SetStateAction<boolean>>;
  agentDetails: AgentMarketPlaceItemWithFilter;
}
const CommingSoonChat = ({ setShowChat, setShowCommingSoonChat, agentDetails }: commingSoonChatProps) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const contentRef = useRef<HTMLDivElement>(null);

  const {
    data: AgentMdContent,
    isLoading: agentMdContentLoading,
    error: AgentMdContentError,
  } = useDownloadAgentMdQuery(agentDetails._id, {
    skip: agentDetails.isPlatformAgent === true || agentDetails.isLive === false,
  });

  useEffect(() => {
    if (AgentMdContentError) {
      showSnackbarErrorMessage(AgentMdContentError as ApiError);
    }
  }, [AgentMdContentError]);

  // Scroll to top when content loads
  useEffect(() => {
    if (AgentMdContent && contentRef.current) {
      // Reset scroll position to top
      window.scrollTo(0, 0);
    }
  }, [AgentMdContent]);

  const changeAgent = () => {
    localStorage.setItem('scrollToWhySection', 'true');
    setShowChat(false);
    setShowCommingSoonChat(false);
  };

  const agentComingSoonDetails = () => {
    return (
      <>
        <Box>
          <Typography variant="h5" sx={{ color: 'black', fontSize: isMobile ? '20px' : '24px', marginLeft: '30px' }}>
            Agent Description
          </Typography>
          <Box
            component="ul"
            sx={{
              marginTop: '10px',
              marginLeft: '45px',
              color: '#555',
              fontSize: isMobile ? '14px' : '16px',
              paddingLeft: '16px',
            }}
          >
            {agentDetails.detailed_description?.split('\n').map((point: any, index: any) => (
              <li key={index}>
                <Typography component="span" variant="body1">
                  {point}
                </Typography>
              </li>
            ))}
          </Box>
        </Box>
        <Box>
          <Typography
            variant="h5"
            sx={{ color: 'black', fontSize: isMobile ? '20px' : '24px', marginLeft: '30px', marginTop: '20px' }}
          >
            Usage Instruction
          </Typography>
          <Box
            component="ul"
            sx={{
              marginTop: '10px',
              marginLeft: '45px',
              color: '#555',
              fontSize: isMobile ? '14px' : '16px',
              paddingLeft: '16px',
            }}
          >
            {agentDetails.usage_instruction?.split('\n').map((point: any, index: any) => (
              <li key={index}>
                <Typography component="span" variant="body1">
                  {point}
                </Typography>
              </li>
            ))}
          </Box>
        </Box>

        <Box>
          <Typography
            variant="h5"
            sx={{ color: 'black', fontSize: isMobile ? '20px' : '24px', marginLeft: '30px', marginTop: '20px' }}
          >
            Use-Case
          </Typography>
          <Box
            component="ul"
            sx={{
              marginTop: '10px',
              marginLeft: '45px',
              color: '#555',
              fontSize: isMobile ? '14px' : '16px',
              paddingLeft: '16px',
            }}
          >
            {agentDetails.use_case?.split('\n').map((point: any, index: any) => (
              <li key={index}>
                <Typography component="span" variant="body1">
                  {point}
                </Typography>
              </li>
            ))}
          </Box>
        </Box>
      </>
    );
  };

  return (
    <>
      <ChatBanner changeAgent={changeAgent} agentDetails={agentDetails} />
      <Box
        ref={contentRef}
        sx={{
          marginX: '50px',
          marginTop: '20px',
          fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
          lineHeight: '1.6',
        }}
      >
        {agentDetails.isLive === false ? (
          agentComingSoonDetails()
        ) : (
          <>
            {agentMdContentLoading && <CircularProgress />}
            {AgentMdContent && <MarkdownRenderer content={AgentMdContent} />}
          </>
        )}
      </Box>
    </>
  );
};

export default CommingSoonChat;
